module.exports = __webpack_public_path__ + "img/contacts.6f5c857b.svg";